import mime from 'mime-types';
import {PatientFile} from "../components/dashboard";
import request from "superagent";
import agent from "../agent";
import {TestIndicator} from "../components/test/TestModel";
import moment from "moment/moment";
import {getTZ} from "../utils/common";

export interface OpenFileOptions {
    file?: PatientFile;
    fileId?: string;
    download?: boolean
}

export class Utils {
    static getRefsText(value: TestIndicator) {
        if (value.max && value.min)
            return value.min + " - " + value.max;
        else if (value.max)
            return "<=" + value.max;
        else if (value.min)
            return ">" + value.max;
        else
            return "-";
    }

    public static vomode(): number {
        return window.config?.vomode || 0;
    }

    public static async openFile(options: OpenFileOptions) {
        try {
            let file = options.file;
            if (!file && options.fileId) {
                file = await agent.FileProvider.open(options.fileId);
            }
            if (!file) return;

            // Получаем файл как ArrayBuffer
            const response = await agent.FileProvider.getFile(file.filename, file.uploadDate);
            if (!response) throw new Error("Данные файла не получены");

            // Определяем MIME-тип и расширение
            let mimeType = file.contentType || this.getMimeTypeFromBuffer(response.body) || "application/octet-stream";
            // Нормализуем MIME-тип (заменяем image/jpg на image/jpeg, т.к. стандартный MIME-тип - image/jpeg)
            if (mimeType.toLowerCase() === 'image/jpg') {
                mimeType = 'image/jpeg';
            }
            if (file.filename.toLowerCase().endsWith('.avi') ||
                mimeType.toLowerCase().includes('avi')) {
                mimeType = 'video/x-msvideo';
            }
            const fileExt = this.getExtensionFromMime(mimeType) ||
                this.getExtensionFromMime(file.filename) ||
                this.guessExtensionFromData(response.body) ||
                ".bin";

            // Создаем Blob с правильным типом
            const fileBlob = new Blob([response.body], { type: mimeType });
            const fileUrl = URL.createObjectURL(fileBlob);

            // Формируем корректное имя файла
            let fileName = file.filename.replace(/\.vnd\..+$/, '');
            if (!fileName.includes('.')) {
                fileName += fileExt.startsWith('.') ? fileExt : `.${fileExt}`;
            }

            if (!options.download) {
                window.open(fileUrl, "mywindow", "menubar=1,resizable=1,width=" + (window.screen.width * 0.4) + ",height=" + window.screen.height + ",location=no");
                setTimeout(() => URL.revokeObjectURL(fileUrl), 10000);
            } else {
                const a = document.createElement('a');
                a.href = fileUrl;
                a.download = fileName;
                a.style.display = 'none';

                document.body.appendChild(a);
                a.click();

                setTimeout(() => {
                    document.body.removeChild(a);
                    URL.revokeObjectURL(fileUrl);
                }, 100);
            }
        } catch (error) {
            console.error("Ошибка при открытии файла:", error);
        }
    }

    public static guessExtensionFromData(buffer: ArrayBuffer): string | undefined {
        try {
            const header = new Uint8Array(buffer.slice(0, 4));
            if (header[0] === 0x50 && header[1] === 0x4B && header[2] === 0x03 && header[3] === 0x04) {
                return '.docx';
            }
        } catch (e) {
            console.error("Не удалось определить расширение файла", e);
        }
        return undefined;
    }

    public static getExtensionFromMime(mimeType: string): string | undefined {
        const ext = mime.extension(mimeType.toLowerCase())
        return typeof ext === 'string' ? ext : undefined;
    }

    public static getMimeTypeFromBuffer(buffer: ArrayBuffer): string | undefined {
        const uintArr = new Uint8Array(buffer.slice(0, 4));
        const hex = Array.from(uintArr).map(b => b.toString(16).padStart(2, '0')).join('').toUpperCase();

        switch(hex) {
            case 'FFD8FFDB':
            case 'FFD8FFE0':
            case 'FFD8FFEE':
            case 'FFD8FFE1': return 'image/jpeg';
            case '89504E47': return 'image/png';
            case '47494638': return 'image/gif';
            case '25504446': return 'application/pdf';
            default: return undefined;
        }
    }

    public static formatDate(date?: Date): string {
        return this.formatDateTime(date, "DD.MM.YY")
    }

    public static formatTime(date?: Date): string {
        return this.formatDateTime(date, "HH:mm:ss")
    }

    public static formatDateTime(date?: Date, pattern?: string): string {
        let _pattern = pattern ?? "DD.MM.YY HH:mm:ss";
        if (date)
            return moment(date).tz(getTZ()).format(_pattern);
        else
            return "";
    }

    public static getFullName(surname?: string, name?: string, middlename?: string): string {
        return [surname, name, middlename]
            .map(part => part?.trim() ?? '')
            .filter(Boolean)
            .join(' ');
    }

}